export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			numbers: [
				{name: "0 Decimal Place", value: 0},
				{name: "1 Decimal Place", value: 1},
				{name: "2 Decimal Places", value: 2},
				{name: "3 Decimal Places", value: 3},
				{name: "4 Decimal Places", value: 4}
			]
		}
	},
	computed: {
		//
	},
};